// AI Generated Test
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { FormUtils } from '@client/ng2/shared/form-utils';
import { NgForm } from '@angular/forms';


import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy-dialog-rule-meta-header',
    templateUrl: './form-global-policy-dialog-rule-meta-header.component.html',
    standalone: false,
})
export class FormGlobalPolicyDialogRuleMetaHeaderComponent implements OnInit, AfterViewInit {
    @Input() cRule: any;
    @Input() monDialogId: any;

    @ViewChild('policyRuleForm') policyRuleForm?: NgForm;

    typeOptions: any[] = [];
    dropdownOptions: any[] = [];
    selectedOperator: any;
    selectedSubEntry: any;
    dateAgeOptions: any[] = [];
    dropdownDateAgeOptions: any[] = [];

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
        private translateService: TranslateService,
        private monDialog: MonDialog,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngAfterViewInit () {
        this.monDialog.setFocus(this.monDialogId, this.policyRuleForm);
    }

    activate (): void {
        if (Array.isArray(this.cRule.sub_entry)) {
            this.cRule.sub_entry = this.cRule.sub_entry.join('');
        }
        this.cRule.inverse = false;
        this.cRule.query = this.cRule.query || '';
        this.policyFormHelperService.setRuleType(this.cRule.type);
        this.setupTypeOptions();
        this.setupSubEntryOptions();
        if (!this.cRule.name) {
            this.chooseOperator(this.typeOptions.length > 0 ? this.typeOptions[0] : {});
        } else {
            this.chooseOperator(
                this.typeOptions.find((type: any) => {
                    return type.type === this.cRule.operator;
                }),
            );
        }
    }

    setupTypeOptions (): void {
        this.typeOptions = this.policyFormHelperService.getOptionsByRuleType();
        this.dropdownOptions = this.policyFormHelperService.getMenuDropdownOptionsByRuleType(option => this.chooseOperator(option));
    }

    chooseOperator (option: any): void {
        this.selectedOperator = option;
        this.cRule.operator = option.type;
        if (this.isDateOperator() && !this.selectedSubEntry) {
            this.chooseSubEntryParameter(this.dateAgeOptions[0]);
        }
    }

    chooseSubEntryParameter (option: any): void {
        this.selectedSubEntry = option;
    }

    getQueryType (): string {
        if (this.isDateOperator()) {
            return 'number';
        }

        return 'text';
    }

    setupSubEntryOptions (): void {
        this.dateAgeOptions = [
            {
                name: this.translateService.getString('Seconds'),
                value: 'second',
            },
            {
                name: this.translateService.getString('Minutes'),
                value: 'minute',
            },
            {
                name: this.translateService.getString('Hours'),
                value: 'hour',
            },
            {
                name: this.translateService.getString('Days'),
                value: 'day',
            },
            {
                name: this.translateService.getString('Months'),
                value: 'month',
            },
            {
                name: this.translateService.getString('Years'),
                value: 'year',
            },
        ];

        this.dropdownDateAgeOptions = this.dateAgeOptions.map(option => {
            return {
                ...option,
                action: () => this.chooseSubEntryParameter(option),
                label: option.name,
            };
        });

        if (this.isDateOperator()) {
            const queryStr = this.cRule.query.replace(/(second|minute|hour|day|month|year)/, '');

            if (queryStr === this.cRule.query) {
                this.chooseSubEntryParameter(this.dateAgeOptions[0]);
            } else {
                const size = this.cRule.query.substring(queryStr.length, this.cRule.query.length);
                this.chooseSubEntryParameter(
                    this.dateAgeOptions.find((option: any) => {
                        return option.value === size;
                    }),
                );
            }

            this.cRule.query = parseInt(queryStr);
        }
    }

    close (): void {
        const newRule = safeClone(this.cRule);
        if (this.isDateOperator()) {
            newRule.query = isNaN(parseInt(newRule.query)) ? 0 : this.cRule.query;
            newRule.query = newRule.query + this.selectedSubEntry.value;
        }
        FormUtils.markFormAsPristine(this.policyRuleForm);
        this.monDialog.close(this.monDialogId, newRule);
    }

    isDateOperator (): boolean {
        return ['date_age_lt', 'date_age_gt'].indexOf(this.cRule.operator) > -1;
    }
}
